module.exports = __webpack_public_path__ + "img/teabig_peng.c1c2d37d.png";